export function formatPhase(phase: string): string {
  const words = phase.replace(/_/g, ' ')
  return words.charAt(0).toUpperCase() + words.slice(1)
}
